import DistrictsMap, { defaultOptions } from './districts_map'

export { DistrictsMap, defaultOptions }
